<template>
  <div>
    <search-hall @submit="submitSearch" />

    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
      @change="fetchData"
    >
      <template slot="images" slot-scope="imgs, record">
        <!--        <span v-if="imgs && imgs.length > 0" class="custom-blue" @click="showImg(record)">{{ imgs[0].response.filename }}</span>-->
        <img v-if="record.image" :src="record.image.url" style="height: 50px;width: 50px" @click="showImg(record)">
      </template>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <!-- 预览图片 -->
    <preview-image
      :visible.sync="previewVisible"
      :image.sync="previewImages"
    />

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchHall from '@/views/tenants/halls/Search'
import PreviewImage from '@/components/PreviewImage'
import { findTenantHallList } from '@/api/tenant'

export default {
  name: 'HallList',
  components: {
    Pagination,
    PreviewImage,
    SearchHall
  },
  data() {
    return {
      data: [],
      loading: true,
      previewVisible: false,
      previewImages: '',
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  created() {
    this.fetchData()
    this.$EventBus.$on('showImg', val => {
      this.previewVisible = true
      this.previewImages = val.image.url
    })
  },
  computed: {
    tenantId() {
      return parseInt(this.$route.params.id)
    },
    columns() {
      return [
        {
          title: '所属殡仪馆',
          dataIndex: 'funeral_home_name',
          width: 200
        },
        {
          title: '厅房名称',
          dataIndex: 'hall_name',
          width: 200
        },
        {
          title: '图片',
          width: 80,
          dataIndex: 'images',
          scopedSlots: { customRender: 'images' }
        },
        {
          title: '状态',
          width: 90,
          dataIndex: 'status_display'
        }
      ]
    }
  },
  methods: {
    showImg(record) {
      this.previewVisible = true
      this.previewImages = record.image.url
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findTenantHallList(this.tenantId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
